import type { StandbyPublicStylist } from '@/api/standby/standbyStylistsQuery';
import { getShortName } from '@/utils/textUtils';

// The public roster passes DB-nullable names through, and getShortName blanks
// a stylist without a first name, so the last name stands in.
export const getStandbyStylistName = ({
  firstName,
  lastName,
}: Pick<StandbyPublicStylist, 'firstName' | 'lastName'>): string =>
  getShortName(firstName, lastName) || lastName?.trim() || '';
